import { useState, useEffect } from 'react'
import api from '../lib/api'

export default function DbHealth() {
  const [data,     setData]     = useState(null)
  const [loading,  setLoading]  = useState(true)
  const [testing,  setTesting]  = useState(null)  // tenant_id probando

  const fetch = () => {
    setLoading(true)
    api.get('/db-health')
      .then(({ data }) => setData(data))
      .catch(() => {})
      .finally(() => setLoading(false))
  }

  useEffect(() => { fetch() }, [])

  const testOne = async (tenantId) => {
    setTesting(tenantId)
    try {
      const { data: result } = await api.get(`/db-health/${tenantId}`)
      setData(prev => ({
        ...prev,
        tenants: prev.tenants.map(t => t.tenant_id === tenantId ? result : t),
      }))
    } finally {
      setTesting(null)
    }
  }

  const latencyColor = (ms) => {
    if (!ms) return 'var(--red)'
    if (ms < 100) return 'var(--green)'
    if (ms < 500) return 'var(--yellow)'
    return 'var(--red)'
  }

  return (
    <>
      <div className="topbar">
        <div className="breadcrumb"><strong>Salud de bases de datos</strong> — Todos los tenants</div>
        <div className="topbar-actions">
          <button className="btn btn-success" onClick={fetch} disabled={loading}>
            {loading ? 'Verificando…' : '↺ Probar todas'}
          </button>
        </div>
      </div>

      <div className="content">
        {data && (
          <div className="three-col">
            <div className="kpi">
              <div className="kpi-header"><span className="kpi-label">Conectadas</span><div className="kpi-icon green">🗄</div></div>
              <div className="kpi-value" style={{ color: 'var(--green)' }}>{data.ok}</div>
              <div className="kpi-sub">de {data.total} tenants</div>
            </div>
            <div className="kpi">
              <div className="kpi-header"><span className="kpi-label">Latencia alta</span><div className="kpi-icon yellow">⚠</div></div>
              <div className="kpi-value" style={{ color: data.warn > 0 ? 'var(--yellow)' : 'inherit' }}>{data.warn}</div>
              <div className="kpi-sub">{'>'} 500ms</div>
            </div>
            <div className="kpi">
              <div className="kpi-header"><span className="kpi-label">Sin conexión</span><div className="kpi-icon red">✕</div></div>
              <div className="kpi-value" style={{ color: data.error > 0 ? 'var(--red)' : 'inherit' }}>{data.error}</div>
              <div className="kpi-sub">Requieren atención</div>
            </div>
          </div>
        )}

        <div className="table-wrap">
          <div className="table-toolbar">
            <span style={{ fontSize: '12px', color: 'var(--muted)' }}>
              Verificado: {data?.checked_at ? new Date(data.checked_at).toLocaleTimeString('es-SV') : '—'}
            </span>
          </div>
          <table>
            <thead>
              <tr>
                <th>Empresa</th>
                <th>BD</th>
                <th>Host</th>
                <th>Estado</th>
                <th>Latencia</th>
                <th>Tamaño</th>
                <th>Conexiones</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {loading && (
                <tr><td colSpan={8} style={{ textAlign: 'center', padding: '24px', color: 'var(--muted)' }}>Verificando BDs…</td></tr>
              )}
              {!loading && (data?.tenants ?? []).map(t => (
                <tr key={t.tenant_id}>
                  <td>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '7px' }}>
                      <div className={`db-dot ${t.status}`} />
                      <span style={{ fontWeight: 600, fontSize: '12px' }}>{t.tenant_name}</span>
                    </div>
                  </td>
                  <td><span className="mono">{t.db_database}</span></td>
                  <td><span className="mono" style={{ color: 'var(--muted)' }}>{t.db_host}:{t.db_port}</span></td>
                  <td>
                    {{ ok:    <span className="badge badge-ok">OK</span>,
                       warn:  <span className="badge badge-warn">Latencia alta</span>,
                       error: <span className="badge badge-err">Sin conexión</span>,
                    }[t.status] ?? <span className="badge badge-neutral">—</span>}
                  </td>
                  <td style={{ fontWeight: 700, color: latencyColor(t.latency_ms) }}>
                    {t.latency_ms != null ? `${t.latency_ms}ms` : 'timeout'}
                  </td>
                  <td style={{ color: 'var(--muted)', fontSize: '12px' }}>
                    {t.size_mb != null ? `${t.size_mb} MB` : '—'}
                  </td>
                  <td style={{ color: 'var(--muted)', fontSize: '12px' }}>
                    {t.connections != null ? t.connections : '—'}
                  </td>
                  <td>
                    <button
                      className="btn btn-secondary btn-sm"
                      onClick={() => testOne(t.tenant_id)}
                      disabled={testing === t.tenant_id}
                    >
                      {testing === t.tenant_id ? '…' : 'Probar'}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Errores detalle */}
        {!loading && (data?.tenants ?? []).filter(t => t.status === 'error').length > 0 && (
          <div className="panel">
            <div className="panel-head" style={{ color: 'var(--red)' }}>⚠ Detalle de errores</div>
            <div className="panel-body" style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
              {(data?.tenants ?? []).filter(t => t.status === 'error').map(t => (
                <div key={t.tenant_id} className="error-banner">
                  <strong>{t.tenant_name}</strong> ({t.db_host}/{t.db_database}): {t.error}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </>
  )
}
